<template>
  <div style="width:100%;height: 100%;">
    <div @click="click" class="pdf">
      pdf
    </div>
    <modal v-model="openIfram" title="PDF阅读器" footer-hide fullscreen>
      <iframe :src="axios.platConfig.fileUri + url" width="100%" height="100%">
      </iframe>
    </modal>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: ["url"],
  data() {
    return {
      openIfram: false
    };
  },
  methods: {
    click() {
      this.openIfram = true;
    }
  }
};
</script>
<style scrope>
.pdf {
  width: 100%;
  height: 100%;
  background: #c12424;
  color: #fff;
  text-align: center;
  font-size: 14px;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// ../common/src/components/pdf.vue